export const ACCESS_PERMISSIONS = {
    SET_PERMISSIONS:'ACCESS_PERMISSIONS.SET_PERMISSIONS'
}